import { CheckIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import classNames from '../../../../../utils/classNames';


function ProgressBarStep({
  currentStep, step, title, href, totalStep,
}) {
  const navigate = useNavigate();
  const isComplete = step < currentStep;
  const isCurrent = step === currentStep;

  const getStatusClasses = () => {
    if (isComplete) {return 'bg-rgpd-blue';}
    if (isCurrent) {return 'border-2 border-rgpd-blue';}
    return 'border-2 border-gray-300';
  };

  const getStepIcon = () => {
    if (isComplete) {return <CheckIcon className="h-6 w-6 text-white" aria-hidden="true" />;}
    if (isCurrent) {return <span className="text-rgpd-blue">{step + 1}</span>;}
    return <span className="text-gray-500">{step + 1}</span>;
  };

  const getTitleClasses = () => {
    if (isComplete) {return 'text-sm font-medium';}
    if (isCurrent) {return 'text-sm font-medium text-rgpd-blue';}
    return 'text-sm font-medium text-gray-500';
  };


  return (
    <div
      className={classNames(
        step === 0 ? 'rounded-t-md 2xl:!border-l-0' : '',
        step === totalStep - 1 ? 'rounded-b-md' : '',
        'overflow-hidden border border-gray-200 2xl:border-0',
      )}
    >
      <a onClick={() => navigate(href)} className="group">
        <span
          className={classNames(
            'absolute left-0 top-0 h-full w-1 2xl:bottom-0 2xl:top-auto 2xl:h-1 2xl:w-full',
            isCurrent ? 'bg-rgpd-blue' : 'bg-transparent group-hover:bg-gray-200',
          )}
          aria-hidden="true"
        />
        <span className={classNames('flex items-center px-6 py-3 text-sm font-medium')}>
          <span className="flex-shrink-0">
            <span className={classNames('flex h-8 w-8 items-center justify-center rounded-full', getStatusClasses())}>
              {getStepIcon()}
            </span>
          </span>
          <span className="mt-0.5 ml-4 flex min-w-0 flex-col justify-center">
            <span className={getTitleClasses()}>{title}</span>
          </span>
        </span>
      </a>
      {step !== 0 && (
        <div className="absolute inset-0 top-0 left-0 hidden w-3 2xl:block" aria-hidden="true">
          <svg
            className="h-full w-full text-gray-300"
            viewBox="0 0 12 82"
            fill="none"
            preserveAspectRatio="none"
          >
            <path d="M0.5 0V31L10.5 41L0.5 51V82" stroke="currentcolor" vectorEffect="non-scaling-stroke" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default ProgressBarStep;
